import { useTranslation } from 'next-i18next';
export const AiTutorBadge = () => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex shrink-0 items-center gap-2xs" data-sentry-component="AiTutorBadge" data-sentry-source-file="AiTutorBadge.tsx">
      <div className="flex size-[16px] items-center justify-center">
        <img src="/assets/ai-tutor/sprite/ai-tutor.webp" alt="AI Tutor" className="size-[16px] object-cover object-left-top" />
      </div>
      <p className="text-caption-lg-semibold text-neutral">
        {t('detail.tutor')}
      </p>
    </div>;
};